import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action';
import { LightboxFilterSelect } from './filters/lightbox_filter_select';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function LightboxBrand(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.BRAND_VIEW];
    const manufacturerTranslationKey = FilterLabelTranslationKeys[Filters.MANUFACTURER];
    const modelTranslationKey = FilterLabelTranslationKeys[Filters.MODEL];

    return (
        <LightboxView
            viewName={FilterSections.BRAND_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>

            <LightboxViewContent>
                <LightboxFilterSelect
                    name={Filters.MANUFACTURER}
                    value={props.brandValue}
                    options={props.brandOptions}
                    labelTranslationKey={manufacturerTranslationKey}
                    provideAllTranslationKey="catalog-filters-manufacturer-select-label-all"
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.brandValue}
                />

                <LightboxFilterSelect
                    name={Filters.MODEL}
                    value={props.brandValue ? props.modelValue : ''}
                    options={props.modelOptions}
                    labelTranslationKey={modelTranslationKey}
                    provideAllTranslationKey="catalog-filters-model-select-label-all"
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!!props.brandValue && !props.modelValue}
                    disabled={!props.brandValue}
                    loading={props.modelOptionsLoading}
                />
            </LightboxViewContent>

            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.saveSection}
            />
        </LightboxView>
    );
}

LightboxBrand.propTypes = {
    brandValue: PropTypes.string.isRequired,
    modelValue: PropTypes.string.isRequired,
    brandOptions: PropTypes.array.isRequired,
    modelOptions: PropTypes.array.isRequired,
    modelOptionsLoading: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
};

export { LightboxBrand };
